export default __webpack_public_path__ + "static/media/untappd-icon.58090f21.png";